import React, { Component } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { closeModalReceptiveProduct } from '../../../actions/purchaseActions'
import { formatURL } from '../../../utils';

export class ModalReceptiveProduct extends Component {
    constructor(props) {
        super(props)
        this.goToSearchPage = this.goToSearchPage.bind(this);
    }

    goToSearchPage() {
        const location = {
            pathname: formatURL(
                this.props.match,
                `/pesquisa/${this.props.match.params.destination}/${this.props.match.params.begin_date}/${this.props.match.params.end_date}/`,
                window.location.search
            ),
        }
        this.props.closeModalReceptiveProduct();
        this.props.history.replace(location);
    }

    render() {
        if (!this.props.isModalReceptiveProductActive)
            return <div />

        return (
            <div className="comp_modalpagamento quotationDateWarning-modal franchise-modal" onClick={this.props.closeModalReceptiveProduct}>
                <div className="modalcontents" onClick={ e => e.stopPropagation()}>
                    <div onClick={this.props.closeModalReceptiveProduct} className="close-btn"> &times; </div>
                    <div className="contents">
                        <div className="modalmiddle">
                            <h3>Confirma que está comprando um seguro Brasil Receptivo?</h3>

                            <p className="text-middle">
                              O seguro de viagem escolhido é uma excelente opção, mas atenção, este plano é exclusivo para passageiros que moram no exterior e virão ao Brasil. Caso sua viagem, seja de uma cidade para outra dentro do Brasil, este não é o seguro ideal para você.
                            </p>
                        </div>
                        <div className="choosecontainer">
                            <div className="optionone">
                                <button className="button" onClick={this.goToSearchPage}>
                                    <span>Voltar à pesquisa</span>
                                </button>
                            </div>
                        </div>
                        <div className="choosecontainer continue">
                            <div className="optionone">
                                <button className="button" onClick={this.props.closeModalReceptiveProduct}>
                                    <span>Continuar</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        isModalReceptiveProductActive: state.purchase.isModalReceptiveProductActive,
    }),
    {
        closeModalReceptiveProduct
    }
)(withRouter(ModalReceptiveProduct));



// WEBPACK FOOTER //
// ./src/components/purchase/modal_receptive_product/ModalReceptiveProduct.jsx